<div class="chooser__wrapper">
  <div class="chooser__header">
   

    <div class="chooser__header__search">
      <rad-text-field 
        class="rad-theme--light"
        [formControl]="formControl"
        label="Search" 
        icon-name="search" 
        icon-size="Sm"
        style="margin-bottom: -48px;">
      </rad-text-field>
    </div>
  </div>

  <div class="chooser__body">
    <overlay-scrollbars
      class="chooser__body-table-wrapper wide"
    >
        <bssh-data-table
          #dataTable
          useClassForChooser="true"
          [gridOptions]="gridOptions"
          (selectionChanged)="onSelectionChanged($event)"
          [requestOptions]="serverSideRequestOptions"
          (gridReady)="onGridReady($event)"
          (onClearSelected)="clearSelected()"
          (columnVisibilityChanged)="onColumnVisibilityChanged($event)"
          showPageSizeController="enable"
          showColumnsSwitcher="enable"
        ></bssh-data-table>
    </overlay-scrollbars>
  </div>
</div>
